import React from 'react'
import type { SalonsListPage as SalonsListPageData } from 'api/api.types'
import { SalonsList } from 'components/PageElements/Salons/SalonsList'
import styles from './SalonsListPage.module.scss'

type SalonsListPageProps = {
  page: SalonsListPageData,
}

/** All salons of all cities */
export const SalonsListPage: React.FC<SalonsListPageProps> = ({ page }) => (
  <div className={styles.container}>
    <h1 className={styles.title}>{page.title}</h1>
    <SalonsList controls={false} />
  </div>
)
